export function logMetaPixelEvent(eventName: string, eventParams?: Record<string, any>): void {
    if (typeof window.fbq !== "undefined") {
      try {
        window.fbq('track', eventName, eventParams || {});
      } catch (error) {
        console.error(`Error logging event '${eventName}':`, error);
      }
    }
}


export {};
